import { Row, Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { SuggestionsQuestion } from "anketa-core/suggestions_question";
import { ContactOptionMap, QuestionsRightsTypes } from "..";
import { OptionsQuestion } from "anketa-core/options_question";
import { OpenQuestion } from "anketa-core/open_question";
import { TextValidator } from "anketa-core/validation";
import { AnketaCheckPermissionOptions, AnketaResourcesEnum } from "shared";
import { getTranslation } from "src/internationalization";
import { ComplexFactory } from "anketa-core/base";
import { Location, User } from "anketa-core/complex";
import { ComplexQuestion } from "anketa-core/complex_question";

ComplexFactory.registerClass({
  name: "ComplexLocation",
  Constructor: Location as new (init?: any) => Location,
  form: Location.getForm,
});
export const locationForm = (
  questionsRights: (
    q: QuestionsRightsTypes,
    options?: AnketaCheckPermissionOptions<AnketaResourcesEnum.questionnaires>,
  ) => void,
  setDefaultValues: boolean,
): Section => {
  const customerPremise = new Section("cpe", [
    new Translation(
      "en",
      getTranslation("en", "anketa.documentation.opsanio.common.cpe.title"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.documentation.opsanio.common.cpe.title"),
    ),
  ]);
  customerPremise.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.documentation.opsanio.common.cpe.description",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.documentation.opsanio.common.cpe.description",
      ),
    ),
  ];
  questionsRights(customerPremise, {
    isInternal: true,
    isExternal: false,
  });

  const email = new SuggestionsQuestion(
    "email",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.documentation.opsanio.common.contact.person.title",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.documentation.opsanio.common.contact.person.title",
        ),
      ),
    ],
    ContactOptionMap.contact,
  );
  email.required = true;
  email.help = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.documentation.opsanio.common.contact.person.description",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.documentation.opsanio.common.contact.person.description",
      ),
    ),
  ];
  email.description = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.documentation.opsanio.common.contact.person.help",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.documentation.opsanio.common.contact.person.help",
      ),
    ),
  ];
  questionsRights(email, {
    isInternal: true,
    isExternal: true,
  });
  customerPremise.addChild(email);

  const location = new ComplexQuestion(
    "location",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.documentation.opsanio.common.address.title",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.documentation.opsanio.common.address.title",
        ),
      ),
    ],
    "ComplexLocation",
  );
  questionsRights(location, {
    isInternal: true,
    isExternal: true,
  });
  customerPremise.addChild(location);

  const rackRequirements = new Row("rack", [
    new Translation(
      "en",
      getTranslation("en", "anketa.documentation.opsanio.common.rack"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.documentation.opsanio.common.rack"),
    ),
  ]);
  rackRequirements.description = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.documentation.opsanio.common.rack.description",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.documentation.opsanio.common.rack.description",
      ),
    ),
  ];
  questionsRights(rackRequirements, {
    isInternal: true,
    isExternal: true,
  });
  customerPremise.addChild(rackRequirements);

  const switchPort = new OptionsQuestion(
    "swsport",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.documentation.opsanio.common.switch.ports",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.documentation.opsanio.common.switch.ports",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  switchPort.required = true;
  questionsRights(switchPort, {
    isInternal: true,
    isExternal: true,
  });

  rackRequirements.addChild(switchPort);

  const hu = new OptionsQuestion(
    "hu",
    [
      new Translation(
        "en",
        getTranslation("en", "anketa.documentation.opsanio.common.rack.hu"),
      ),
      new Translation(
        "de",
        getTranslation("de", "anketa.documentation.opsanio.common.rack.hu"),
      ),
    ],
    "default.options.yes_no",
  );
  hu.required = true;
  questionsRights(hu, {
    isInternal: true,
    isExternal: true,
  });

  rackRequirements.addChild(hu);

  const twoSws = new OptionsQuestion(
    "twosws",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.documentation.opsanio.common.switch.connection",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.documentation.opsanio.common.switch.connection",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  twoSws.required = true;
  questionsRights(twoSws, {
    isInternal: true,
    isExternal: true,
  });
  rackRequirements.addChild(twoSws);

  const airGap = new OptionsQuestion(
    "airgap",
    [
      new Translation(
        "en",
        getTranslation("en", "anketa.documentation.opsanio.common.air.gaped"),
      ),
      new Translation(
        "de",
        getTranslation("de", "anketa.documentation.opsanio.common.air.gaped"),
      ),
    ],
    "default.options.yes_no",
  );
  airGap.required = true;

  questionsRights(airGap, {
    isInternal: true,
    isExternal: true,
  });
  rackRequirements.addChild(airGap);

  const twoRoom = new Row("tworoom", [
    new Translation(
      "en",
      getTranslation("en", "anketa.documentation.opsanio.common.room.title"),
    ),
    new Translation(
      "de",
      getTranslation("de", "anketa.documentation.opsanio.common.room.title"),
    ),
  ]);
  questionsRights(twoRoom, {
    isInternal: true,
    isExternal: true,
  });

  customerPremise.addChild(twoRoom);
  twoRoom.description = [
    new Translation(
      "en",
      getTranslation(
        "en",
        "anketa.documentation.opsanio.common.room.description",
      ),
    ),
    new Translation(
      "de",
      getTranslation(
        "de",
        "anketa.documentation.opsanio.common.room.description",
      ),
    ),
  ];
  const twoRoomQuestion = new OptionsQuestion(
    "tworoomq",
    [
      new Translation(
        "en",
        getTranslation(
          "en",
          "anketa.documentation.opsanio.common.room.question",
        ),
      ),
      new Translation(
        "de",
        getTranslation(
          "de",
          "anketa.documentation.opsanio.common.room.question",
        ),
      ),
    ],
    "default.options.yes_no",
  );
  questionsRights(twoRoomQuestion, {
    isInternal: true,
    isExternal: true,
  });

  twoRoom.addChild(twoRoomQuestion);

  if (setDefaultValues) {
    switchPort.setFactValue(0);
    hu.setFactValue(0);
    twoRoomQuestion.setFactValue(1);
    airGap.setFactValue(1);
    twoSws.setFactValue(1);
  }
  return customerPremise;
};
